import {createListenerMiddleware} from '@reduxjs/toolkit';
import SegmentUtils from '@spothero/utils/segment';
import {toNumber} from 'lodash-es';
import {
    getInitialFacilities,
    setFilteredFacilities,
} from 'pages/facilities/store/facilities-actions';
import {isRateGuidanceActive} from 'utils/experiments';
import {RootState} from 'store/store';

export const analyticsMiddleware = createListenerMiddleware<RootState>();

/**
 * When `getInitialFacilities` is fulfilled, identifies the user and sets user
 * traits using SegmentUtils.
 */
analyticsMiddleware.startListening({
    actionCreator: getInitialFacilities.fulfilled,
    effect: (action, listenerApi) => {
        const {
            user: {
                data: {user_id: userId, email},
            },
            facilities: {
                meta: {totalFacilityCount},
            },
            experiments,
        } = listenerApi.getState();

        const isRateGuidanceEligible = isRateGuidanceActive(experiments.data);

        SegmentUtils.identify({
            uniqueId: userId,
            traits: {
                email,
                'Facility Count': totalFacilityCount,
                'Rate Guidance Eligible': isRateGuidanceEligible,
            },
        });
    },
});

/**
 * When `setFilteredFacilities` is fulfilled, sends a Segment tracking event with
 * the filtered facility IDs and the current user segment.
 */
analyticsMiddleware.startListening({
    actionCreator: setFilteredFacilities.fulfilled,
    effect: (action, listenerApi) => {
        const {
            user: {segment},
            facilities: {filteredFacilities},
        } = listenerApi.getState();

        // TODO: handle type casting upstream at the store level
        const filteredFacilityIds = filteredFacilities.ids.map(toNumber);

        SegmentUtils.track({
            event: 'Filtered Facilities',
            properties: {
                'Facility IDs': filteredFacilityIds,
                'Filtered Facility Count': filteredFacilities.ids.length,
                user: segment,
            },
        });
    },
});

/**
 * On router location changes, re-identifies the user through SegmentUtils.
 */
analyticsMiddleware.startListening({
    type: '@@router/LOCATION_CHANGE',
    effect: (action, listenerApi) => {
        const {
            user: {
                data: {user_id: userId, email},
            },
        } = listenerApi.getState();

        SegmentUtils.identify({
            uniqueId: userId,
            traits: {
                email,
            },
        });
    },
});
